import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@stores/store';
import useUserDetails from '@hooks/api/useUserDetails';
import UserAuth from '@services/auth';

/**
 * useInitializeUser
 *
 * Hook to automatically fetch user details when a user is authenticated
 * but user data hasn't been loaded yet.
 *
 * This is useful for layouts that need to ensure user data is available
 * for authenticated users without manually triggering the fetch.
 */
const useInitializeUser = () => {
  const appData = useSelector((state: RootState) => state?.AppData);
  const userDetails = useSelector((state: RootState) => state?.UserData);

  const [isAuthenticationComplete, setIsAuthenticationComplete] = useState(false);

  const { getUserDetails } = useUserDetails();

  const token = appData?.auth?.access_token || UserAuth.accessToken || '';

  useEffect(() => {
    fetchUserDetails();
  }, [userDetails, token]);

  const fetchUserDetails = async () => {
    if (token && !userDetails?.user?.id) {
      await getUserDetails();
      setIsAuthenticationComplete(true);
    } else {
      setIsAuthenticationComplete(true);
    }
  };

  return { isAuthenticationComplete };
};

export default useInitializeUser;
